import { CompanyLinkMapper } from "@/adapters/CompanyLink.mapper";
import { isB2BErrorBody, toB2BError, toDataShapeError } from "@/utils/b2bErrors";
import { lazyService } from "@/utils/lazyMock";
import { supabase } from "@/utils/supabase";
export class CompanyLinkService {
    async getCompanyLinks(companyId, state) {
        let query = supabase()
            .from("v_corp_links")
            .select("*")
            .eq("company_id", companyId)
            .order("created_at", { ascending: false });
        if (state)
            query = query.eq("state", state);
        const { data, error } = await query;
        if (error)
            throw toB2BError(error);
        try {
            return (data ?? []).map(CompanyLinkMapper.rowToDomain);
        }
        catch (parseError) {
            throw toDataShapeError(parseError);
        }
    }
    async getClientLinks(clientId, state) {
        let query = supabase()
            .from("v_corp_client_links")
            .select("*")
            .eq("client_id", clientId)
            .order("created_at", { ascending: false });
        if (state)
            query = query.eq("state", state);
        const { data, error } = await query;
        if (error)
            throw toB2BError(error);
        try {
            return (data ?? []).map(CompanyLinkMapper.rowToDomain);
        }
        catch (parseError) {
            throw toDataShapeError(parseError);
        }
    }
    async addLink(companyId, input) {
        const { data, error } = await supabase().rpc("corp_link_add", {
            p_company_id: companyId,
            p_phone: input.phone,
            p_valid_from: input.validFrom,
            p_valid_to: input.validTo,
            p_employee_label: input.employeeLabel,
        });
        if (error)
            throw toB2BError(error);
        // CCR-008: отказ может прийти телом без исключения ({code, details}) — разбор тот же, по details.
        if (isB2BErrorBody(data))
            throw toB2BError(data);
        return CompanyLinkMapper.addResultToDomain(data);
    }
    async updateLink(linkId, patch) {
        const { data, error } = await supabase().rpc("corp_link_update", {
            p_link_id: linkId,
            p_patch: patch,
        });
        if (error)
            throw toB2BError(error);
        return CompanyLinkMapper.changeResultToDomain(data);
    }
    async setBlocked(linkId, blocked, reason) {
        const { data, error } = await supabase().rpc("corp_link_set_blocked", {
            p_link_id: linkId,
            p_blocked: blocked,
            p_reason: reason,
        });
        if (error)
            throw toB2BError(error);
        return CompanyLinkMapper.changeResultToDomain(data);
    }
}
// Литерал REACT_APP_B2B_MOCK — см. CompanyService.ts / utils/lazyMock.ts (G4).
export const companyLinkService = process.env.REACT_APP_B2B_MOCK === "true"
    ? lazyService(() => import("@/services/mock/CompanyLinkServiceMock").then((module) => module.companyLinkServiceMock))
    : new CompanyLinkService();
